import type { StockShortage } from '~/server/utils/stockShortages'

/** 400 body of a counter order that stock can't cover, or null for any other error. */
export function stockShortagesFromError(error: unknown): StockShortage[] | null {
  const e = error as { data?: { data?: { code?: string, shortages?: StockShortage[] } } } | null
  const data = e?.data?.data
  if (data?.code !== 'INSUFFICIENT_STOCK' || !Array.isArray(data.shortages)) return null
  return data.shortages
}

/**
 * `/inventory/bulk-update` body for the quick count in the shortage dialog:
 * each row the cashier filled sets that item's real total (`set` mode, reason
 * `correction`, same code as a physical count correction). Empty rows are left out.
 */
export function buildShortageAdjustPayload(shortages: StockShortage[], counts: Record<string, number | null | undefined>) {
  const updates = shortages
    .filter(s => counts[shortageKey(s)] !== null && counts[shortageKey(s)] !== undefined)
    .map(s => ({
      id: s.id,
      type: s.kind,
      inputValue: Number(counts[shortageKey(s)]),
    }))
  return { updates, reason: 'correction', notes: 'POS: stock shortage', adjustmentMode: 'set' as const }
}

export function shortageKey(s: Pick<StockShortage, 'kind' | 'id'>): string {
  return `${s.kind}:${s.id}`
}
